import script from "./daftar.vue?vue&type=script&setup=true&lang=ts"
export * from "./daftar.vue?vue&type=script&setup=true&lang=ts"

import "./daftar.vue?vue&type=style&index=0&id=bc78ca4e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bc78ca4e"]])

export default __exports__